import React from 'react';
import PropTypes from 'prop-types';
import Fade from 'react-reveal/Fade';
import SquareListElem from 'components/Components/Includes/SquareListElem';
import {clusterUrl} from 'utils/routing-helper';

function ClustersSection({
    clusters, title, destinationSlug, parentDestinationSlug, regionSlug, hotel,
})
{
    return (
        <section id="clusters" className="tw-pt-10 lg:tw-pt-20 tw-px-4">
            <Fade bottom>
                <h2 className="font-arapey tw-text-4xl lg:tw-text-5xl tw-font-normal tw-text-gray-700 leading-12 tw-text-center">{title}</h2>
            </Fade>

            <div className="tw-flex tw-flex-wrap tw-justify-center tw-mt-16 lg:tw-mt-16">
                {clusters.map(cluster => (
                    <SquareListElem
                        key={cluster.id}
                        link={clusterUrl(regionSlug, parentDestinationSlug, destinationSlug, hotel.slug, cluster.url)}
                        image={cluster.clusterImg}
                        title={cluster.title}
                        onClickQuote={null}
                    />
                ))}
            </div>
        </section>
    );
}

ClustersSection.defaultProps = {
    title: 'More Information',
};

ClustersSection.propTypes = {
    clusters: PropTypes.array.isRequired,
    title: PropTypes.string,
    destinationSlug: PropTypes.any,
    parentDestinationSlug: PropTypes.any,
    regionSlug: PropTypes.string.isRequired,
    hotel: PropTypes.object.isRequired,
};

export default ClustersSection;
